import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import Input from '../../Input';
import { QueryOptions } from '../../Utils/QueryOptions';
import { FilterTypes } from '../Components';

class InputRangeFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      from: null,
      to: null,
    };

    this.refRangeDa = createRef();
    this.refRangeA = createRef();
  }

  handleKeyDown = (evt) => {
    const { item } = this.props;
    const { from, to } = this.state;

    //  Enter code
    if (evt.keyCode === 13) {
      const da = isNaN(parseInt(from, 10)) ? null : parseInt(from, 10);
      const a = isNaN(parseInt(to, 10)) ? null : parseInt(to, 10);

      if (da === null || a === null || da > a) {
        return;
      }

      const filter = {};
      filter.from = da;
      filter.to = a;

      this.notifyAddFilter(
        item.propertyName,
        QueryOptions.RANGE,
        evt,
        null,
        {
          clearFields: this.clearFields,
          values: filter,
        },
        FilterTypes.RANGE,
        item.customFilter,
      );

      this.setState({
        from: null,
        to: null,
      });
    }
  };

  notifyAddFilter = (...filter) => {
    const { addFilter } = this.props;

    addFilter && addFilter(...filter);
  };

  clearFields = () => {
    this.refRangeDa.clear();
    this.refRangeA.clear();
  };

  handleFromChange = (evt) => {
    this.setState({
      from: evt.target.value,
    });
  };

  handleToChange = (evt) => {
    this.setState({
      to: evt.target.value,
    });
  };

  render() {
    const {
      item,
    } = this.props;

    return (
      <div className="filter__campoRicerca" style={item.width && { width: item.width.toString() }}>
        <div className="range">
          <Input
            onChange={this.handleFromChange}
            onKeyDown={this.handleKeyDown}
            ref={(r) => { this.refRangeDa = r; }}
            title={`${item.description || item.propertyName} da`}
          />
          <Input
            onChange={this.handleToChange}
            onKeyDown={this.handleKeyDown}
            ref={(r) => { this.refRangeA = r; }}
            title={`${item.description || item.propertyName} a`}
          />
        </div>
      </div>
    );
  }
}

InputRangeFilter.propTypes = {
  /** Callback invocata all'aggiunta di un termine di filtro */
  addFilter: PropTypes.func.isRequired,
  /** Descrittore del filtro da applicare */
  item: PropTypes.shape({
    propertyName: PropTypes.string.isRequired,
    description: PropTypes.string,
    width: PropTypes.number,

    // eslint-disable-next-line react/forbid-prop-types
    customFilter: PropTypes.array,
  }).isRequired,
};

export default InputRangeFilter;
